import styled from "styled-components";

export const ClearGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

export const ClearGroupBtn = styled.div`
  text-decoration: underline;
  cursor: pointer;
`